import React, { useMemo } from "react";
import { Table, Spinner } from "reactstrap";

const fmtMoney = (n) => {
  const x = Number(n || 0);
  return x.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const asISODate = (v) => (v ? String(v).slice(0, 10) : "");

const RecouvrementSummaryTable = ({ data, loading, onSelectDate }) => {
  const rows = useMemo(() => {
    const arr = Array.isArray(data) ? [...data] : [];
    arr.sort((a, b) => asISODate(a.dateEcheance).localeCompare(asISODate(b.dateEcheance)));
    return arr;
  }, [data]);

  if (loading) {
    return (
      <div className="py-4 text-center" style={{ color: "#6b7280" }}>
        <Spinner size="sm" className="me-2" /> Chargement…
      </div>
    );
  }

  if (!rows.length) {
    return <div className="py-4 text-center" style={{ color: "#6b7280" }}>Aucune échéance sur la période.</div>;
  }

  return (
    <div style={{ border: "1px solid #e5e7eb", borderRadius: 14, overflow: "hidden" }}>
      <Table responsive borderless className="mb-0">
        <thead style={{ background: "#f8fafc", borderBottom: "1px solid #e5e7eb" }}>
          <tr>
            <th style={{ fontSize: 12, color: "#334155", fontWeight: 900 }}>Date</th>
            <th className="text-end" style={{ fontSize: 12, color: "#334155", fontWeight: 900 }}>Chèques</th>
            <th className="text-end" style={{ fontSize: 12, color: "#334155", fontWeight: 900 }}>Total (MAD)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, idx) => {
            const d = asISODate(r.dateEcheance);
            return (
              <tr key={`${d}-${idx}`} style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ fontSize: 13, fontWeight: 800, color: "#0f172a" }}>
                  {d || "—"}
                </td>

                <td className="text-end" style={{ fontSize: 13, color: "#334155" }}>
                  {Number(r.count || 0)}
                </td>

                <td className="text-end">
                  <button
                    type="button"
                    onClick={() => onSelectDate && onSelectDate(d)}
                    style={{
                      border: "1px solid #e5e7eb",
                      background: "#ffffff",
                      borderRadius: 12,
                      padding: "6px 10px",
                      fontWeight: 900,
                      color: "#0f172a",
                      cursor: "pointer",
                      minWidth: 140,
                      textAlign: "right",
                    }}
                    title="Voir les chèques"
                  >
                    {fmtMoney(r.total)} MAD
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default RecouvrementSummaryTable;